<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idsemana" :options="datos" track-by="id" label="nombre"
        :searchable="false" :multiple="true" :close-on-select="false" :show-labels="false" placeholder="Seleccione..."></multiselect>
    </div>
</template>

<script>
export default {
    props:{ model:Object },
    data(){
        return{
            datos: [],
            modelo: {
                idsemana: null,
            }
        }
    },
    watch:{
        'modelo.idsemana': function(){this.model.idsemana=this.modelo.idsemana; },
    },
    methods:{
        getDatos(){
          this.datos.push( {id:'dia1',nombre:'Lunes'} );
          this.datos.push( {id:'dia2',nombre:'Martes'} );
          this.datos.push( {id:'dia3',nombre:'Miercoles'} );
          this.datos.push( {id:'dia4',nombre:'Jueves'} );
          this.datos.push( {id:'dia5',nombre:'Viernes'} );
          this.datos.push( {id:'dia6',nombre:'Sabado'} );
          this.datos.push( {id:'dia7',nombre:'Domingo'} );
        }
    },
    mounted(){
        this.getDatos();
    }
}
</script>